import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ListTicketComponent } from 'modules/ticket/list-ticket/list-ticket.component';
import { CreateTicketComponent } from 'modules/ticket/create-ticket/create-ticket.component';
import { FillTicketAttributeComponent } from 'modules/ticket/fill-ticket-attribute/fill-ticket-attribute.component';
import { TicketAttributeCardComponent } from 'modules/ticket/ticket-attribute-card/ticket-attribute-card.component';
import { TicketCardComponent } from 'modules/ticket/ticket-card/ticket-card.component';
import { SelectedTicketComponent } from 'modules/ticket/selected-ticket/selected-ticket.component';
import { ArcgisModule } from 'modules/arcgis/arcgis.module';
import { UpdateTicketComponent } from 'modules/ticket/update-ticket/update-ticket.component';
import { ListHybridTicketsComponent } from 'modules/ticket/list-hybrid-tickets/list-hybrid-tickets.component';
import { EsriTicketComponent } from 'modules/ticket/esri-ticket/esri-ticket.component';
import { SharedModule } from 'modules/shared/shared.module';
import { StatProjectComponent } from 'modules/project/stat-project/stat-project.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploadTicketFileComponent } from './upload-ticket-file/upload-ticket-file.component';
import { GalleryTicketComponent } from './gallery-ticket/gallery-ticket.component';
import { SoundListComponent } from './sound-list/sound-list.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    ListTicketComponent,
    CreateTicketComponent,
    FillTicketAttributeComponent,
    TicketAttributeCardComponent,
    TicketCardComponent,
    SelectedTicketComponent,
    UpdateTicketComponent,
    ListHybridTicketsComponent,
    EsriTicketComponent,
    StatProjectComponent,
    UploadTicketFileComponent,
    GalleryTicketComponent,
    SoundListComponent
  ],
  imports: [
    CommonModule,
    ArcgisModule,
    SharedModule,
    MatGridListModule,
    MatExpansionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatButtonToggleModule,
    MatNativeDateModule,
    MatInputModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forChild([
      {
        path: 'list',
        component: ListTicketComponent,
        canActivate: [],
      },
      {
        path: 'hybrid',
        component: ListHybridTicketsComponent,
        canActivate: [],
      },
      {
        path: 'esri',
        component: EsriTicketComponent,
        canActivate: [],
      },
      {
        path: 'create',
        component: CreateTicketComponent,
        canActivate: [],
      },
      {
        path: 'update',
        component: UpdateTicketComponent,
        canActivate: [],
      },
    ]),
  ],
  exports: [
    EsriTicketComponent,
    ListTicketComponent,
    TicketAttributeCardComponent,
  ],
  entryComponents: [
    GalleryTicketComponent,
    SoundListComponent,
  ]
})
export class TicketModule { }
